import { render } from "./BFormRadioGroup.vue?vue&type=template&id=70a63c46&scoped=true"
import script from "./BFormRadioGroup.vue?vue&type=script&lang=js"
export * from "./BFormRadioGroup.vue?vue&type=script&lang=js"

import "./BFormRadioGroup.vue?vue&type=style&index=0&id=70a63c46&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70a63c46"]])

export default __exports__